/**
 * SmartcapHeroSlider
 * Custom element — fade slideshow for the SmartCap hero section.
 * Manages opacity-based transitions, dot navigation, and auto-advance.
 * Respects prefers-reduced-motion and re-initialises in Shopify theme editor.
 */
class SmartcapHeroSlider extends HTMLElement {
  connectedCallback() {
    this._slides = Array.from(this.querySelectorAll('.sc-hero__slide'));
    this._dots   = Array.from(this.querySelectorAll('.sc-hero__dot'));
    this._current = this._slides.findIndex(s =>
  s.classList.contains('sc-hero__slide--active')
);
if (this._current === -1) this._current = 0;
    this._timer   = null;
    this._speed   = parseInt(this.dataset.speed, 10) || 5000;
    this._autoplay = this.dataset.autoplay === 'true';

    this._dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this._stopAutoplay();
        this._goTo(i);
        if (this._autoplay) this._startAutoplay();
      });
    });

    if (this._autoplay && this._slides.length > 1) {
  setTimeout(() => this._startAutoplay(), this._speed);
}

    this._onSectionLoad = (event) => {
      const section = this.closest(`#shopify-section-${event.detail.sectionId}`);
      if (!section) return;
      this._stopAutoplay();
      this._goTo(0);
      if (this._autoplay && this._slides.length > 1) {
  setTimeout(() => this._startAutoplay(), this._speed);
}
    };

    document.addEventListener('shopify:section:load', this._onSectionLoad);
  }

  disconnectedCallback() {
    this._stopAutoplay();
    document.removeEventListener('shopify:section:load', this._onSectionLoad);
  }

  _goTo(index) {
    const prev = this._current;

    this._slides[prev].classList.remove('sc-hero__slide--active');
    if (this._dots[prev]) {
      this._dots[prev].classList.remove('sc-hero__dot--active');
      this._dots[prev].setAttribute('aria-selected', 'false');
    }

    this._current = index;

    this._slides[this._current].classList.add('sc-hero__slide--active');
    if (this._dots[this._current]) {
      this._dots[this._current].classList.add('sc-hero__dot--active');
      this._dots[this._current].setAttribute('aria-selected', 'true');
    }
  }

  _startAutoplay() {
    this._timer = setInterval(() => {
      this._goTo((this._current + 1) % this._slides.length);
    }, this._speed);
  }

  _stopAutoplay() {
    if (this._timer) {
      clearInterval(this._timer);
      this._timer = null;
    }
  }
}

if (!customElements.get('smartcap-hero-slider')) {
  customElements.define('smartcap-hero-slider', SmartcapHeroSlider);
}
